// Replaces the old Electron-era header indicator in the Layout header slot.
//
// The old indicator showed sync progress, download progress and a work-mode
// switcher, all of which belonged to the Electron local-database path. This
// shows the one fact that is still true and still useful: whether the backend
// is reachable.
import React from 'react';
import { useSync } from '../../context/SyncContext';
import { useLanguage } from '../../context/LanguageContext';
import { C } from '../../styles/theme';

const TONES = {
    online: { dot: C.green, bg: C.greenLight, text: C.greenDark },
    reconnecting: { dot: C.amber, bg: C.amberLight, text: C.amber },
    offline: { dot: C.red, bg: C.redLight, text: C.redText },
};

// Exported for testing: the mapping is the part worth asserting.
export function badgeState({ isOnline, reconnecting }) {
    if (!isOnline) return { tone: 'offline', labelKey: 'connection_offline' };
    if (reconnecting) return { tone: 'reconnecting', labelKey: 'connection_reconnecting' };
    return { tone: 'online', labelKey: 'connection_online' };
}

const ConnectionBadge = () => {
    const { isOnline, reconnecting } = useSync();
    const { t } = useLanguage();
    const { tone, labelKey } = badgeState({ isOnline, reconnecting });
    const c = TONES[tone];

    return (
        <div
            role="status"
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                padding: '4px 10px', borderRadius: 999,
                background: c.bg, color: c.text,
                fontSize: 11, fontWeight: 700,
                textTransform: 'uppercase', letterSpacing: 0.8,
            }}
        >
            <span style={{
                width: 7, height: 7, borderRadius: '50%', background: c.dot,
            }} />
            {t(labelKey)}
        </div>
    );
};

export default ConnectionBadge;
